import styled from 'styled-components'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'

export const StyledNotificationItem = styled(Flexbox)<{$isAlert?: boolean}>(
    ({theme: {palette, spacing}, $isAlert}) => `
        padding: ${spacing * 4}px;
        cursor: pointer;
        transition: background-color 0.2s ease-in-out;
        background-color: ${$isAlert ? palette.orange['100'] : palette.neutral.white};
        &:hover {
            background-color: ${palette.neutral['50']};
        }
        
    `
)

export const StyledNotificationTime = styled.span(
    ({theme: {typography, palette}}) => `
        ${typography.textXs};
        color: ${palette.neutral['500']};
    `
)

export const StyledNotificationUnreadDot = styled.div(
    ({theme: {palette}}) => `
        min-width: 8px;
        width: 8px;
        height: 8px;
        background-color: ${palette.primary['500']};
        border-radius: 50%;
    `
)
